export default __webpack_public_path__ + "static/media/ContactUsImage.a081f879.png";